import { fetchApi } from '@/config/api'
import type { PrestationApiResponse, PrestationsApiData } from '@/types/prestationApi'


export class PrestationsApi {
  
  /**
   * Récupère toutes les prestations visibles
   */
  static async getVisiblePrestations(): Promise<PrestationApiResponse[]> {
    const fields = `
          id_prestation
          libelle
          description
          montant
    `
    const query = (withImage: boolean) => `
      query {
        prestationsVisible {
          ${fields}
          ${withImage ? 'imageUrl' : ''}
        }
      }
    `

    try {
      const response = await fetchApi<PrestationsApiData>(query(true))
      return response.prestationsVisible
    } catch (error) {
      const message = error instanceof Error ? error.message : ''
      if (!message.includes('imageUrl')) throw error
      const response = await fetchApi<PrestationsApiData>(query(false))
      return response.prestationsVisible
    }
  }

  /**
   * Récupère toutes les prestations (y compris cachées)
   */
  static async getAllPrestations(): Promise<PrestationApiResponse[]> {
    const query = `
      query {
        prestations {
          id_prestation
          libelle
          description
          montant
          visible
          supprimer
        }
      }
    `
    
    const response = await fetchApi<{ prestations: PrestationApiResponse[] }>(query)
    return response.prestations
  }

  /**
   * Récupère une prestation par son ID
   */
  static async getPrestationById(id: number): Promise<PrestationApiResponse | null> {
    const query = `
      query GetPrestation($id: Int!) {
        prestation(id: $id) {
          id_prestation
          libelle
          description
          montant
        }
      }
    `
    
    const response = await fetchApi<{ prestation: PrestationApiResponse | null }>(query, { id })
    return response.prestation
  }
}

// Export des méthodes pour une utilisation plus simple
export const prestationsApi = {
  getVisible: PrestationsApi.getVisiblePrestations,
  getAll: PrestationsApi.getAllPrestations,
  getById: PrestationsApi.getPrestationById
}
